module.exports = __webpack_public_path__ + "static/media/design-slacks.c80ff884.svg";